<template>
    <div class="cart__item-line cart__item-line--1">
        <div class="cart__item-img-block"><img class="cart__item-img" :src="cartitemLocal.img" alt=""/></div>
        <div class="cart__item-info"><a class="cart__item-link" :href="cartitemLocal.url">{{ cartitemLocal.name }}</a>
            <div v-if="cartitemLocal.variant_id > 0">{{ cartitemLocal.variant_name }}</div>
            <div class="complect" v-if="cartitemLocal.bundle_id > 0">комплект</div>
            <div class="cart__item-desc">{{ cartitemLocal.name_rus}}</div>
            <div class="cart__item-info-line">
                <div class="cart__item-artnumber">Арт. {{ cartitemLocal.article }}</div>

                <div v-if="cartitemLocal.is_predzakaz" class="cart__item-status cart__item-status--pre-order">
                    <svg class="cart__item-status-icon" width="12" height="12">
                        <use xlink:href="#icon-check"></use>
                    </svg>
                    <div class="cart__item-status-text">Предзаказ</div>
                </div>
                <div v-else class="cart__item-status cart__item-status--available">
                    <svg class="cart__item-status-icon" width="12" height="12">
                        <use xlink:href="#icon-check"></use>
                    </svg>
                    <div class="cart__item-status-text">В НАЛИЧИИ</div>
                </div>
                <div class="pl-2 text-success" v-if="cart_item.discount_name">{{ cart_item.discount_name }}</div>
            </div>
            <div v-if="cartitemLocal.is_predzakaz" class="text-danger">Товар находится в пути. Вы гарантированно получаете данную модель сразу при поступлении на склад.</div>
            <div class="text-danger">{{ this.getDiscountMessage(cart_item)}}</div>
        </div>
        <div class="cart__item-offer">
            <div class="cart__item-price">
                <div v-if="cart_item.summ_price_rur > cart_item.summ_cost_rur" class="cart__item-old-price">{{ cart_item.summ_price_rur | formatCurrency }}</div>
                <div class="cart__item-cur-price">{{ cart_item.summ_cost_rur | formatCurrency}} ₽</div>
            </div>
            <div v-if="cart_item.summ_price_rur > cart_item.summ_cost_rur" class="cart__item-profit">Выгода {{ cart_item.summ_price_rur - cart_item.summ_cost_rur | formatCurrency }} ₽</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cart-list-item",
        props: ['cartitem'],
        data () {
            return {
                cartitemLocal:this.cartitem
            }
        },
        computed: {
            cart_item () {
                const cart_items = this.$store.getters.cartitems;
                let product =cart_items.filter((item) => {
                    return item.id===this.cartitemLocal.id;
                });
                return product[0];
            }
        },
        methods: {
            getDiscountMessage(cartitem) {
                if(this.$store.getters.pc_discount) {
                    if(cartitem.summ_cost_rur >= cartitem.summ_price_rur) {
                        return 'На этот товар не действует скидка по промокоду';
                    }
                }
                return ''
            }
        }
    }
</script>

<style scoped>
    .complect {
        font-weight: bold;
    }
</style>
